module.exports = __webpack_public_path__ + "static/media/bulk_upload.16846ebf.PNG";